import img1 from "../imgs/login/lateral-image-1.jpg";
import img2 from "../imgs/login/lateral-image-2.jpg";
import img3 from "../imgs/login/lateral-image-3.jpg";

const LoginImgs = [img1, img2, img3];

export default LoginImgs;